import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiBarChart2, FiUsers, FiFileText, FiStar } from "react-icons/fi";
import "./widgets.css";

const UserStatsWidget = ({ stats }) => {
  if (!stats) return null;

  const statItems = [
    {
      icon: FiUsers,
      iconClass: "cbx-stat-icon--blue",
      value: stats.followers?.toLocaleString() || 0,
      label: "Followers",
    },
    {
      icon: FiFileText,
      iconClass: "cbx-stat-icon--green",
      value: stats.posts || 0,
      label: "Posts",
    },
  ];

  if (stats.reputation !== undefined) {
    statItems.push({
      icon: FiStar,
      iconClass: "cbx-stat-icon--amber",
      value: stats.reputation?.toLocaleString() || 0,
      label: "Rep",
    });
  }

  return (
    <motion.div
      className="cbx-widget cbx-widget--stats"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="cbx-widget__header">
        <h3 className="cbx-widget__title">
          <FiBarChart2 className="cbx-widget__title-icon" />
          Your Stats
        </h3>
      </div>

      <div className="cbx-stats-grid">
        {statItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <motion.div
              key={item.label}
              className="cbx-stat-item"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
            >
              <Icon className={`cbx-stat-icon ${item.iconClass}`} />
              <span className="cbx-stat-value">{item.value}</span>
              <span className="cbx-stat-label">{item.label}</span>
            </motion.div>
          );
        })}
      </div>

      <Link to="/profile" className="cbx-view-profile-btn">
        View Full Profile →
      </Link>
    </motion.div>
  );
};

export default UserStatsWidget;
